import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

interface Props {
  datasetId: string;
  filterableOnly?: boolean;
}

const useAbacusColumnsMetadata = ({ datasetId, filterableOnly = true }: Props) =>
  useQuery(['abacus-columns-metadata', datasetId, filterableOnly], () =>
    peApi.getAbacusColumnsMetadata(datasetId, filterableOnly)
  );

export default useAbacusColumnsMetadata;
